import { TUseFilterAndPricesReturn } from 'hooks/useFilterAndPrices';
import { createContext } from 'react';


export const GroupFilterContext = createContext<TUseFilterAndPricesReturn>({} as TUseFilterAndPricesReturn);